import React, {useEffect, useRef} from 'react'
import './header.css'
import CTA from './CTA';
import Me from '../../assets/me2.jpg'
import { init } from "ityped";
import HeaderSocials from './HeaderSocials';
const Header = () => {
  const textRef = useRef();
  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["Python (Web Scraping, ML, CV, etc.)","Django (Full Stack)", "Flutter (Android Development)", "React (Front-End)", "MATLAB (Robotics and ML)", "ESP32 and Arduino (Embedded)","Proteus (Circuit Design)", "SolidWorks"],
    });
  }, []);
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>ALi</h1>
        <h2>Mechatronics Engineer and Full Stack Developer</h2>
        <h5 className="text-light">With handson Experience in <span ref={textRef}></span></h5>
        <CTA/>
        <HeaderSocials/>
        <div className="me">
          <img src={Me} alt="" />
        </div>
        <a href="#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header